// extracted by mini-css-extract-plugin
export default {"titles":"rzZvOD3JuDyu9D0NZLdX","stats":"a14cBQb_Tu_jDHmi1q44","notActive":"IslfVaph_j6OmeYdd1Hf"};